/* global gsap */

export default class MainMenu {
	constructor() {
		this.offCanvas = document.getElementById('navbarNavOffcanvas');
		this.imagePlaceholder = this.offCanvas && this.offCanvas.querySelector('.images-placeholder');
		this.burgerButtonWrapper = document.querySelector('.burger-button-wrapper');
		this.menuItems = document.querySelectorAll('#primary-menu > .menu-item');
		this.menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children .nav-link');
		this.bottomArea = this.offCanvas && this.offCanvas.querySelector('.bottom-area');
		this.isWorking = false;
		this.isMobile = window.innerWidth < 768;
		this.events();
	}

	onMenuItemWithImageMouseEnter(ev) {
		if (this.isMobile) return true;
		const el = ev.currentTarget;

		this.imagePlaceholder && this.imagePlaceholder.querySelectorAll('.image').forEach(e => e.classList.remove('active'));

		if (el.dataset.imageUrl === '') {
			this.imagePlaceholder && this.imagePlaceholder.querySelector('[data-id="init"]').classList.add('active');
		} else {
			Array.from(this.imagePlaceholder.querySelectorAll('[data-id]')).find( e => e.dataset.id === el.id ).classList.add('active');
		}
	}

	onKeyUpListener(ev) {
		if (ev.keyCode === 27) {
			document.querySelector('.burger-button-wrapper').dispatchEvent(new Event('click'));
		}

		return true;
	}

	onMainMenuOpen() {
		if (this.isWorking) return false;
		if (!this.offCanvas) return false;
		this.isWorking = true;
		const tl = gsap.timeline();
		this.offCanvas.classList.toggle('active');

		this.offCanvas.removeAttribute('aria-hidden');
		this.offCanvas.setAttribute('aria-modal', true);
		this.offCanvas.setAttribute('role', 'dialog');
		this.offCanvas.style.visibility = 'visible';

		document.body.classList.add('is-menu-open');

		gsap.set(this.menuItems, {opacity: 0, y: '20px'});
		gsap.set(this.bottomArea, {opacity: 0, y: '100%'});

		tl.to(this.offCanvas, {x: 0, duration: 0.6, onComplete: () => {
			if (this.isMobile) {
				window.dispatchEvent(new Event('mainMenu.open'));
				this.isWorking = false;
			}
		}});

		gsap.to(this.bottomArea, {opacity: 1, y: 0, duration: 0.6, ease: "power4.inOut", delay: 0.4});
		tl.to(this.menuItems, {opacity: 1, y: 0, duration: 0.4, ease: "power4.inOut", stagger: 0.1}, "-=0.3");

		if (!this.isMobile) {
			tl.to(this.imagePlaceholder, {x: 0, duration: 1.2, ease: "power4.out", onComplete: () => {
					document.addEventListener('keyup', this.onKeyUpListener.bind(this), {once: true});
					document.body.classList.add('is-menu-open');
					window.dispatchEvent(new Event('mainMenu.open'));
					this.isWorking = false;
					// console.log('open completed');
				}}, "-=" + this.menuItems.length * 0.125);
		}

	}

	onMainMenuClose() {
		if (this.isWorking) return false;
		if (!this.offCanvas) return false;
		this.isWorking = true;
		const tl = gsap.timeline();
		this.offCanvas.classList.toggle('active');

		this.offCanvas.removeAttribute('aria-modal');
		this.offCanvas.removeAttribute('role');
		this.offCanvas.setAttribute('aria-hidden', true);

		document.body.classList.remove('is-menu-open');


		if (!this.isMobile) {
			tl.to(this.imagePlaceholder, {x: '-100%', duration: 0.4});
		}

		tl.to(this.offCanvas, { x: '-100%', duration: 0.6, onComplete: () => {
				this.offCanvas.style.visibility = 'hidden';
				this.isWorking = false;
				window.dispatchEvent(new Event('mainMenu.close'));
			}}, "-=0.2");
	}

	onMenuItemWithChildrenMouseClick(ev) {
		const linkEl = ev.currentTarget;
		const subMenu = linkEl.nextElementSibling;
		if (!subMenu) return;

		if (linkEl.classList.contains('active')) {
			return;
		}

		ev.preventDefault();

		this.menuItemsWithChildren.forEach(el => {
			if (el === linkEl) return;
			el.classList.remove('active');
			el.nextElementSibling.style.maxHeight = '0';
		});

		if (linkEl.classList.contains('active')) {
			linkEl.classList.remove('active');
			subMenu.style.maxHeight = '0';
		} else {
			linkEl.classList.add('active');
			subMenu.style.maxHeight = '115px';
		}
	}

	onMenuItemWithChildrenMouseOver(ev) {
		if ( window.innerWidth >= 1200 ) {
			if (!ev.currentTarget.classList.contains('active')) {
				ev.currentTarget.dispatchEvent(new Event('click'));
			}
		}
	}

	events() {
		document.querySelectorAll('.menu-item[data-image-url]').forEach( el => el.addEventListener('mouseenter', this.onMenuItemWithImageMouseEnter.bind(this), false));

		if (this.offCanvas) {
			this.offCanvas.addEventListener('burgerButton.open', this.onMainMenuOpen.bind(this), false);
			this.offCanvas.addEventListener('burgerButton.close', this.onMainMenuClose.bind(this), false);
		}

		if (this.menuItemsWithChildren) {
			this.menuItemsWithChildren.forEach(el => {
				el.addEventListener('click', this.onMenuItemWithChildrenMouseClick.bind(this), false);
				el.addEventListener('mouseover', this.onMenuItemWithChildrenMouseOver.bind(this), false);
			});
		}
	}
}
